import { useTranslation } from "react-i18next";
import { Link } from "wouter";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  const { t } = useTranslation();
  return (
    <section className="py-12 text-center">
      <h1>404</h1>
      <p className="mt-3 text-muted-foreground">{t("common:notFound")}</p>
      <Button asChild className="mt-6">
        <Link href="/">{t("common:backHome")}</Link>
      </Button>
    </section>
  );
}
